import React from 'react';

import { Tooltip } from '@material-ui/core';
import { StyledBox, StyledTypography } from 'styles/common';

import { convertDateToString4 } from 'constants/helper';
import theme from 'constants/theme';

const DateComponent = (props) => {
  const { date, message, placement, color = 'textPrimary', bgColor = 'grey', compact } = props;
  return (
    <Tooltip
      title={message}
      placement={placement || 'left'}
      disableFocusListener={!message}
      disableHoverListener={!message}
      disableTouchListener={!message}
    >
      <StyledBox
        padding={compact ? '0.25rem 0.75rem' : '0.5rem 2rem'}
        bgcolor={theme.palette.background[bgColor]}
        borderRadius={4}
        flexcontainer
        justifycontent="center"
        alignitems="center"
      >
        <StyledTypography variant="body1" color={color} weight={600}>
          {date ? convertDateToString4(new Date(Date.parse(date))) : '-'}
        </StyledTypography>
      </StyledBox>
    </Tooltip>
  );
};

export default DateComponent;
